angular.module('zc.zenclerkS')
  .controller('ZcsAgencyCreateSiteController', ZcsAgencyCreateSiteController);

ZcsAgencyCreateSiteController.$inject = ['$scope', '$state', '$stateParams', 'AgencyProject', 'agency', 'regions', 'salesEntities'];
function ZcsAgencyCreateSiteController($scope, $state, $stateParams, AgencyProject, agency, regions, salesEntities) {
  const vm = this;
  vm.site = {};
  vm.regions = regions;
  vm.salesEntities = salesEntities;
  vm.agency = agency;
  vm.site.shopping_cart_asp = agency.default_shopping_cart_asp;
  vm.showCartId = showCartId;
  vm.save = save;

  if($stateParams.demo) {
    AgencyProject.setDemoData(vm.site);
  }

  if(!agency.is_direct_selling) {
    vm.site.sales_entity = agency.sales_entity;
  }

  vm.shopping_cart_asp_options = [
    { value: '', label: 'agencies.sites.createSiteController.sentaku_shitekudasai', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu'},
    { value: 'aishipr', label: 'aishipR', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu'},
    { value: 'base', label: 'BASE', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu'},
    { value: 'cartstar', label: 'CARTSTAR', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.tenpo_koodo'},
    { value: 'color_me_shop', label: 'カラーミーショップ', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.akaunto'},
    { value: 'commerce_21', label: 'コマース21', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu'},
    { value: 'e_shops', label: 'e-shopsカート2', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu'},
    { value: 'ebisumart', label: 'ebisumart', invoice_calculation_type: 'normal', id_name: 'ebisumart No'},
    { value: 'ec_cube', label: 'EC-CUBE', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu'},
    { value: 'ecbeing', label: 'ecbeing', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu'},
    { value: 'fc2', label: 'FC2ショッピングカート', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu'},
    { value: 'futureshop2', label: 'FutureShop2', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.tenpo'},
    { value: 'makeshop', label: 'MakeShop', invoice_calculation_type: 'normal', id_name: 'agencies.sites.createSiteController.shoppu'},
    { value: 'ocnk_net', label: 'おちゃのこネット', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu'},
    { value: 'os_commerce', label: 'osCommerce', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu'},
    { value: 'shopmaker', label: 'ショップメーカー', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu'},
    { value: 'shopserve', label: 'ショップサーブ', invoice_calculation_type: 'normal', id_name: 'agencies.sites.createSiteController.shoppu'},
    { value: 'shopify', label: 'Shopify', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu'},
    { value: 'stores', label: 'STORES.jp', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu'},
    { value: 'tamago_repeat', label: 'たまごリピート', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu'},
    { value: 'vtex', label: 'Vtex', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu'},
    { value: 'zencart', label: 'Zen Cart', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu'},
    { value: 'other', label: 'agencies.sites.createSiteController.sonohoka', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu'},
  ];

  $scope.$watch('vm.site.shopping_cart_asp', shoppingCartAspChanged);

  function shoppingCartAspChanged(shoppingCartAsp) {
    const asp = _.find(vm.shopping_cart_asp_options, { value: shoppingCartAsp });
    if(asp) {
      vm.site.invoice_calculation_type = asp.invoice_calculation_type;
      vm.id_name = asp.id_name;
    }
  }

  function showCartId() {
    return vm.site.shopping_cart_asp !== 'other' &&
      vm.site.shopping_cart_asp !== 'ec_cube' &&
      vm.site.shopping_cart_asp !== 'base';
  }

  function save(site) {
    return AgencyProject.create($stateParams.agencyName, site)
      .then(res => $state.go('zenclerkS.agency.sites', { agencyName: $stateParams.agencyName }, { reload: true }));
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/agencies/sites/agency_create_site.controller.js